import React from "react";
import { Link } from "react-router-dom";
import Icon from "react-icons-kit";
import { tags } from "react-icons-kit/fa/tags";

import GoogleAdContainer from "components/Ads/GoogleAdContainer";
import allHashTags from "components/Properties/AllHashTags";
import SocialMediaIcons from "components/CustomWidgets/SocialMediaIcons";

class Left extends React.Component {
  render() {
    return (
      <div className="col-12 col-md-3 col-lg-2" style={{ marginTop: "1rem" }}>
        {/* Hash Tags Section */}
        <div className="mb-4">
          <div className="d-flex align-items-center mb-3">
            <Icon icon={tags} size={20} className="me-2" />
            <h6 className="mb-0 fw-bold">Click to search by hash tag</h6>
          </div>
          <div className="solidlineLight mb-3"></div>
          <div className="d-flex flex-wrap gap-2" style={{ padding: "0.5rem 0" }}>
            {allHashTags.hashTags.map((tag, key) => (
              <Link
                key={key}
                to={tag === "java" ? "/java-programming/" : `/${tag}/`}
                className={`badge btn-${allHashTags.hashTagColors[key]} text-decoration-none`}
                style={{ whiteSpace: 'nowrap' }}
              >
                #{tag}
              </Link>
            ))}
          </div>
        </div>

        {/* Gumroad Banners */}
        <div className="row g-4 mb-5" style={{ maxWidth: '100%', overflow: 'hidden' }}>
          <div className="col-12" style={{ maxWidth: '100%' }}>
            <a 
              href="https://gumroad.com/discover?a=660051347" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="d-block hover-scale"
              style={{ maxWidth: '100%' }}
            >
              <img 
                src="https://raw.githubusercontent.com/learninjavagithub/assets/master/gumroad.jpg" 
                alt="Gumroad Discover" 
                className="img-fluid rounded shadow-sm"
                style={{ 
                  height: 'auto', 
                  maxWidth: '100%',
                  display: 'block',
                  margin: '0 auto'
                }}
                loading="lazy"
              />
            </a>
          </div>
          <div className="solidlineLight my-5"></div>
          <div className="col-12" style={{ maxWidth: '100%' }}>
            <a 
              href="https://techbites.gumroad.com/l/ymooyj" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="d-block hover-scale"
              style={{ maxWidth: '100%' }}
            >
              <img 
                src="https://github.com/learninjavagithub/assets/raw/master/techbites-gumroad.gif" 
                alt="Tech Bites Resume Templates" 
                className="img-fluid rounded shadow-sm"
                style={{ 
                  height: 'auto', 
                  maxWidth: '100%',
                  display: 'block',
                  margin: '0 auto'
                }}
                loading="lazy"
              />
            </a>
          </div>
          <div className="solidlineLight my-5"></div>
          <div className="col-12" style={{ maxWidth: '100%' }}>
            <a 
              href="https://www.etsy.com/listing/4441471962/java-interview-questions-coding-test" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="d-block hover-scale"
              style={{ maxWidth: '100%' }}
            >
              <img 
                src="https://github.com/learninjavagithub/assets/raw/master/codecrack-ai-cover-page.png" 
                alt="CodeCrack AI - AI Coding Interview Evaluator" 
                className="img-fluid rounded shadow-sm"
                style={{ 
                  height: 'auto', 
                  maxWidth: '100%',
                  display: 'block',
                  margin: '0 auto'
                }}
                loading="lazy"
              />
            </a>
          </div>
        </div>

        {/* Ad Container */}
        <div className="mb-5">
          <GoogleAdContainer position="square1" />
        </div>

        <div className="solidlineLight my-5"></div>

        {/* Social Media Icons */}
        <div className="mb-5 text-center">
          <SocialMediaIcons color="themed" type="square" />
        </div>

        <div className="solidlineLightBottom my-5"></div>

        {/* Second Ad Container */}
        <div>
          <GoogleAdContainer position="square2" />
        </div>
      </div>
    );
  }
}

export default Left;
